import { useIsMutating } from '@tanstack/react-query';

import { ESHOP_MUTATION_KEY } from '../model';
import { useCartQuery } from './queries/useCartQuery';

export const useInteractionWithCartIndicator = () => {
    const { isRefetching } = useCartQuery();
    const isSubmitCouponMutating = useIsMutating({ mutationKey: [ESHOP_MUTATION_KEY.SUBMIT_COUPON] });
    const isSetDeliveryOptionsMutating = useIsMutating({ mutationKey: [ESHOP_MUTATION_KEY.SET_DELIVERY_OPTIONS] });
    const isVatConfigMutating = useIsMutating({ mutationKey: [ESHOP_MUTATION_KEY.VAT_CONFIG] });
    const isUpdateNetflixMutating = useIsMutating({ mutationKey: [ESHOP_MUTATION_KEY.UPDATE_NETFLIX] });
    const isUpdateDisneyMutating = useIsMutating({ mutationKey: [ESHOP_MUTATION_KEY.UPDATE_DISNEY] });

    return (
        isRefetching ||
        isSubmitCouponMutating ||
        isSetDeliveryOptionsMutating ||
        isVatConfigMutating ||
        isUpdateNetflixMutating ||
        isUpdateDisneyMutating
    );
};
